export default __webpack_public_path__ + "static/wire3-2856f436ead2f39ad738a6b83a2a5314.png";